//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingPeriodController_delete,
  Response$AdminBillingPeriodController_delete$Status$200,
  ResponseContentType$AdminBillingPeriodController_delete,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingPeriodController_delete = () =>
  useApiClientMutation<
    Params$AdminBillingPeriodController_delete,
    Response$AdminBillingPeriodController_delete$Status$200[ResponseContentType$AdminBillingPeriodController_delete]
  >({ method: 'AdminBillingPeriodController_delete' });
